import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';

import {createSelector} from "reselect";

import {topoUtils} from '../utils/topo-utils';
import {geoUtils} from '../utils/geo-utils';


/**
 * Component for drawing the outline of the selected State for the County map.
 *
 * @property height - height of the parent svg in pixels for placement
 * @property width - width of the parent svg in pixels for placement
 * @property stateFips - numeric state fips value to retrieve state shape
 * @property fillColor - string hex color value for the drawn path fill def. #e8e8e8
 * @property strokeColor - string hex color value for the drawn path stroke def. #373737

 * @example
 * return (
 *   <StateOutline
 *     width={500}
 *     height={500}
 *     stateFips={1}
 *   />
 * )
 */
export default class StateOutline extends PureComponent {

  static propTypes = {
    width: PropTypes.number,
    height: PropTypes.number,
    fillColor: PropTypes.string,
    strokeColor: PropTypes.string,
    stateFips: PropTypes.number
  };

  static defaultProps = {
    fillColor: '#e8e8e8',
    strokeColor: '#373737'
  }

  getFips = (props) => props.stateFips
  getWidth = (props) => props.width
  getHeight = (props) => props.height

  getTopography = createSelector(
    [this.getFips],
    (fips) => topoUtils.getStateTopography(fips)
  )

  getPath = createSelector(
    [this.getFips, this.getWidth, this.getHeight],
    (fips, width, height) => geoUtils.getAlbersStatePath(fips, width, height)
  )

  getStrokeWidth = createSelector(
    [this.getWidth],
    (width) => width > 500 ? 4 : 2.25
  )

  render() {
    const {fillColor, strokeColor} = this.props;
    const topo = this.getTopography(this.props);
    const path = this.getPath(this.props);
    const strokeWidth = this.getStrokeWidth(this.props);

    return (
      <g className="StateOutline">
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          fill={fillColor}
          stroke={strokeColor}
          strokeWidth={strokeWidth}
          d={path(topo.land)}
        />
      </g>
    )
  }
}
